import { useMemo } from 'react';
import { useNode } from '@craftjs/core';
import { AppDropdownField } from 'src/features/generalForms/uikit/fields/dropdown/dropDownField';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import {
  TitlePanel,
  AnswersPanel,
  DropdownPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import {
  FormDropdownInputComponent,
  FormDropdownInputProps,
} from 'src/features/generalForms/builder/types/DropdownInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';

export const FormMultipleDropdownInput: FormDropdownInputComponent = (props) => {
  const {
    actions: { setProp },
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const validationResult = useDataKeyValidation();

  const options: DropdownOption[] = useMemo(
    () =>
      props.options?.map((option) => ({
        key: option.key,
        text: option.value,
      })) ?? [],
    [props.options],
  );

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppDropdownField<DropdownOption>
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        isMultiple={true}
        placeholder={props.placeholder}
        suggestion={props.suggestion}
        isRequired={true}
        disabled={props.disabled}
        options={options}
        value={options.filter((o) => props.defaultValue?.includes(o.key)) || []}
        onChange={(v) => {
          setProp((p: FormDropdownInputProps) => (p.defaultValue = v?.length ? v.map((x) => x.key) : undefined), 500);
        }}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormMultipleDropdownInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <DropdownPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormMultipleDropdownInput.craft = {
  displayName: 'Dropdown multiselect',
  rules: { canDrag: () => true },
  related: { settings: FormMultipleDropdownInputSettings },
};
